import { useEffect, useState } from "react";
import { CategoriesResponse } from "../services/coworkerApiCalls/Category/CategoriesTypes";
import { useOktaAuth } from "@okta/okta-react";
import { getCategories } from "../services/coworkerApiCalls/Category/Category";
import { categoryResponsesToCategories } from "../services/helpers/CategoryMapper";

function useDataApiCategories() {
    const [category, setCategory] = useState<CategoriesResponse>();

    const { authState } = useOktaAuth();
    
    const token = authState!.idToken!.idToken


    useEffect(() => {
        const getAllCategories = async () => {

            const categoryTemporary = await getCategories(token);
            const categoryResult = categoryResponsesToCategories(categoryTemporary);
            setCategory(categoryResult);

        };
        void getAllCategories();

    }, [token]); // Or [] if effect doesn't need props or state
    
    return category;
}
export { useDataApiCategories }